<form [formGroup]='loginForm' (ngSubmit)='submitForm(loginForm)'>


    <div *ngIf="error" class="alert alert-danger">
        {{error}}
    </div>

    <br/>

 
   

    <label >email :</label>
    <input  formControlName="email"  type="email" class="form-control mb-2" >
    <div *ngIf="loginForm.get('email').errors && loginForm.get('email').touched"  class="alert border border-danger">
        <p *ngIf="loginForm.get('email').errors.required">email is Required</p>
        <p *ngIf="loginForm.get('email').errors.email">email invalid</p>

    </div>
  


    <label >password :</label>
    <input  formControlName="password"  type="password" class="form-control mb-2" >
    <div *ngIf="loginForm.get('password').errors && loginForm.get('password').touched"  class="alert border border-danger">
        <p *ngIf="loginForm.get('password').errors.required">password is Required</p>
        <p *ngIf="loginForm.get('password').errors.pattern"> password must include a-z from 3-10</p>
        

    </div>
    <p class="text-white">dont have account ? <a class="text-white" routerLink='/register'>register now</a></p>

    <button type="submit" [disabled]='loginForm.invalid' class="btn btn-info float-right">login</button>

</form>